import { useSearchParams as useSearchParamsRouter } from "react-router-dom";

export const useSearchParams = () => {
    const [params] = useSearchParamsRouter();
    return {
        get: (key: string) => params.get(key),
    } as const;
};
